import React, { FC } from 'react';
import Typography from 'src/common/components/Typography';
import Rating from '../Rating';
import type { RatingProps } from '../Rating';
import Avatar from '../Avatar';
import { User } from '../../types/api/v4/boats/search';
import UniversalLink from '../UniversalLink';

import styles from './SearchReview.module.scss';
import ReviewDate from '../ReviewDate';

const linkTitle = (href: string, title: string) => (
  <UniversalLink
    href={href}
    className={styles.link}
  >
    {title}
  </UniversalLink>
);

export type SearchReviewProps = {
  author: Pick<User, 'first_name' | 'last_name' | 'photo_url' | 'has_photo'>;
  date: string;
  content?: string;
  listingTitle?: string;
  listingUrl?: string;
} & Partial<Pick<RatingProps, 'rating' | 'size' | 'theme' >>;

const SearchReview: FC<SearchReviewProps> = (
  {
    author,
    date,
    listingTitle,
    listingUrl,
    content,
    rating,
    size,
    theme,
  },
) => (
  <li className={styles.root}>
    <div className={styles.top}>
      <div className={styles.avatar}>
        <Avatar
          user={author}
          size="medium"
        />
      </div>
      <div className={styles.info}>
        <div className={styles.nameMonth}>
          <Typography
            type="p"
            size="body-l"
            weight="semibold"
          >
            {author.first_name}
          </Typography>
          <div className={styles.date}>
            <Typography
              type="p"
              size="body-s"
              weight="regular"
            >
              <ReviewDate date={date} />
            </Typography>
          </div>
        </div>
        <Rating
          rating={rating}
          size={size}
          theme={theme}
          fullHeight
        />
      </div>

    </div>
    <div className={styles.text}>
      {listingTitle && (
        <Typography
          type="p"
          size="body-l"
          weight="semibold"
        >
          {listingUrl ? linkTitle(listingUrl, listingTitle) : listingTitle}
        </Typography>
      )}
      {content && (
        <Typography
          type="p"
          size="body-m"
          weight="regular"
          className={styles.content}
        >
          {content}
        </Typography>
      )}
    </div>
  </li>
);

export default SearchReview;
